import { ViewProfileState } from './../reducers/user.view.reducer';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import { IUserState } from './../../state/user.state';
import { AccountVM } from '../../../models/account';

export const getUserState = createFeatureSelector<IUserState>('user');

export const selectViewProfile = createSelector(
    getUserState,
    (state: IUserState) => state.viewProfile
);

export const selectUserProfile = createSelector(
    selectViewProfile,
    (state: ViewProfileState) => state.userProfile
);

export const selectTaxStatus = createSelector(
    selectViewProfile,
    (state: ViewProfileState) => state.taxStatus
);

export const selectUserAddress = createSelector(
    selectViewProfile,
    (state: ViewProfileState) => state.userAddress
);

export const selectUserFirstName = createSelector(
    selectUserProfile,
    (state: AccountVM) => state.firstName
);

export const getUsersVerificationStatus = createSelector(
    selectUserProfile,
    (state: AccountVM) => {
        if (state) {
            return state.verificationStatus;
        }
    }
);

export const getUserRequiredToSetTwoFactorAuthenticationStatus = createSelector(
    selectViewProfile,
    (state: ViewProfileState) => state.requireUserToSetTwoFactorAuthentication
);

export const getUserInvitations = createSelector(
    getUserState,
    (state: IUserState) => state.invitation.invitations
);

export const userInvitationsLoading = createSelector(
    getUserState,
    (state: IUserState) => state.invitation.loading
)